import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Modal, Button, Row, Col, Carousel } from 'react-bootstrap'
import SimpleFormat from '@16g/react-simple-format'
import BookNowButton from '../../ui/BookNowButton'

@inject("modalContainer")
@observer
export default class EmployeeModal extends React.Component {
  static propTypes = {
    employee: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    modalContainer: PropTypes.any.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired
  }

  render() {
    const { show, onClose, modalContainer, employee, showBookNowButton, bookNowButtonText } = this.props

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        container={modalContainer}
      >
        <Modal.Header closeButton>
          <Modal.Title>{ employee.attributes.name }</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={8}>
              <Carousel>
                <Carousel.Item>
                  <img src={employee.attributes.primaryImage.videoVariant} />
                </Carousel.Item>
                { employee.attributes.additionalImages.map((image, index) =>
                  <Carousel.Item key={index}>
                    <img src={image.videoVariant} />
                  </Carousel.Item>
                )}
              </Carousel>
            </Col>
            <Col sm={4}>
              <SimpleFormat text={employee.attributes.bio} />

            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <BookNowButton showBookNowButton={showBookNowButton} bookNowButtonText={bookNowButtonText} />
          <Button onClick={onClose} >Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

